$(document).ready(function () {
    $('#iyarnForm').on('submit', function (e) {
        e.preventDefault();

        let fullName = $('#fullName').val(),
            schoolName = $('#schoolName').val(),
            schoolRole = $('#schoolRole').val(),
            workRole = $('#workRole').val(),
            email = $('#email').val(),
            phone = $('#phoneNumber').val();

        const IS_VALID_EMAIL = $('[type=email]')[0].checkValidity();

        if (IS_VALID_EMAIL) {
            $.ajax({
                url: $('#ajax_url').val(),
                type: 'POST',
                cache: false,
                data: {
                    action: 'send_email',
                    fullName: fullName,
                    schoolName: schoolName,
                    schoolRole: schoolRole,
                    workRole: workRole,
                    email: email,
                    phone: phone,
                },
                success: function (res) {
                    successBusinessSend(res);
                }
            });
        }
    });
});
